import React from 'react';
import { Box } from '@styleseat/ui';
import { JoinEntryCardCarouselProps } from './types';
import { CardCarousel } from '../../../ui/CardCarousel';
import { JoinEntryCard } from './JoinEntryCard';

export const JoinEntryCardCarousel = ({
  cards,
  testID,
  breakpoints,
  screenWidth,
}: JoinEntryCardCarouselProps) => (

  <CardCarousel
    controlsDisabled={false}
    pagingEnabled
    testID={`join-entry-card-carousel-${testID}`}
  >
    {cards.map((card, idx) => (
      <Box
        key={card.title}
        paddingLeft={idx !== 0 ? 4 : 0}
        paddingRight={idx !== cards.length - 1 ? 4 : 0}
        paddingY={2}
        alignItems="stretch"
        height="100%"
        style={{
          marginLeft: idx === 0 ? 8 : 0,
        }}
      >
        <JoinEntryCard
          {...card}
          breakpoints={breakpoints}
          screenWidth={screenWidth}
        />
      </Box>
    ))}
  </CardCarousel>
);
